import { settings } from './settings'

export default {
  clientSideID: settings.LAUNCH_DARKLY_CLIENT_ID,
  evaluationReasons: true
}
